import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  isCollapse: boolean;
  isMobileMenuOpen: boolean;
};

const getInitialMobileMenuOpen = () => {
  const stored = localStorage.getItem("isMobileMenuOpen");
  if (stored !== null) {
    return stored === "true";
  }
  return true;
};

const initialState: InitialState = {
  isCollapse: false,
  isMobileMenuOpen: getInitialMobileMenuOpen(),
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setIsCollapse(state, action: PayloadAction<{ isCollapse: boolean }>) {
      state.isCollapse = action.payload.isCollapse;
    },
    setIsMobileMenuOpen(state, action: PayloadAction<boolean>) {
      state.isMobileMenuOpen = action.payload;
      localStorage.setItem("isMobileMenuOpen", String(action.payload));
    },
  },
});

export const { setIsCollapse, setIsMobileMenuOpen } = sidebarSlice.actions;

export default sidebarSlice;
